
















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import { exportToCSV, DatabaseHeader } from './tables/database';

import * as FLUTES_QUERY from 'src/graphql/admin/Flutes.graphql';
import * as CREATE_FLUTE_QUERY from 'src/graphql/admin/CreateFlute.graphql';
import * as EDIT_FLUTE_QUERY from 'src/graphql/admin/EditFlute.graphql';
import * as DELETE_FLUTE_QUERY from 'src/graphql/admin/DeleteFlute.graphql';

@Component({
  apollo: {
    flutes: {
      query: FLUTES_QUERY,
      fetchPolicy: 'cache-and-network',
    },
  }
})
export default class FluteDatabase extends Vue {
  search = '';
  dialog = false;
  deleteDialog = false;
  valid = true;
  savingAs = false;

  requiredRules = [
    v => !!v || 'This field is required',
  ];

  requiredNumberRules = [
    v => typeof(v) == 'number' || 'This field is required',
  ];

  nameRules = [
    v => !!v || 'This field is required',
    v => this.checkUniqueName(v),
  ];

  editedItem = {
    id: -1,
    name: "",
    company: "",
    company_abbreviation: "",
    wavelength: 0,
    waveheight: 0,
    shear_stiffness: 0,
    takeup_factor: 0,
    weight_limit: 0,
    knockdown_limit: 0,
    knockdown_slope: 0,
    TST_alpha: 0,
    TST_eta: 0
  };

  defaultItem = {
    id: -1,
    name: "",
    company: "",
    company_abbreviation: "",
    wavelength: 0,
    waveheight: 0,
    shear_stiffness: 0,
    takeup_factor: 0,
    weight_limit: 0,
    knockdown_limit: 0,
    knockdown_slope: 0,
    TST_alpha: 0,
    TST_eta: 0
  };

  headers: DatabaseHeader[] = [
    { text: 'Name',          value: 'name', class: 'fixed-column' },
    { text: 'Company',       value: 'company' },
    { text: 'Company Abbr.', value: 'company_abbreviation' },
    { text: 'Wave Length',   value: 'wavelength',      unit: 'm' },
    { text: 'Wave Height',   value: 'waveheight',      unit: 'm' },
    { text: 'Shear Stiff.',  value: 'shear_stiffness', unit: 'Nm' },
    { text: 'Takeup Factor', value: 'takeup_factor' },
    { text: 'Weight Limit',  value: 'weight_limit',    unit: 'kg/m²' },
    { text: 'Knockd. Limit', value: 'knockdown_limit' },
    { text: 'Knockd. Slope', value: 'knockdown_slope' },
    { text: 'TST Alpha',     value: 'TST_alpha' },
    { text: 'TST Eta',       value: 'TST_eta' },
  ];

  flutes = [];

  editedIndex = -1;

  checkUniqueName(name) {
    if (this.editedIndex != -1 && !this.savingAs)
      return true;

    if (name == null)
      return false;

    const found = this.flutes.some( flute => flute.name.toLowerCase() === name.toLowerCase() );
    console.log(`Found flute ${name}: ${found}`);
    return !found || 'Flute already exists';
  }

  get formTitle () {
    return this.editedIndex === -1 ? 'New flute' : 'Edit flute';
  }

  editItem(item) {
    this.editedIndex = this.flutes.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  close() {
    this.dialog = false;

    setTimeout(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    }, 300)
  }

  save() {
    this.savingAs = false;

    const form = this.$refs.form as any;
    if (!form.validate()) {
      return;
    }

    if (this.editedIndex > -1) {
      this.editFlute();
    } else {
      this.createFlute();
    }

    this.close();
  }

  saveAs() {
    this.savingAs = true;

    const form = this.$refs.form as any;
    const valid = form.validate();

    this.savingAs = false;

    if (!valid) {
      return;
    }

    this.createFlute();
    this.close();
  }

  onExport() {
    exportToCSV('Flutes', this.headers, this.flutes);
  }

  closeDelete() {
    this.deleteDialog = false;
  }

  deleteFlute() {
    this.$apollo.mutate({
      mutation: DELETE_FLUTE_QUERY,
      variables: { id: this.editedItem.id },
      update: (store, {data: { deleteFlute }}) => {
        let data: any = store.readQuery({
          query: FLUTES_QUERY
        });

        data.flutes = data.flutes.filter(
          flute => flute.id !== deleteFlute
        );

        store.writeQuery({
          query: FLUTES_QUERY,
          data
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        deleteFlute: this.editedItem.id,
      },
    });

    this.closeDelete();
    this.close();
  }

  createFlute() {
    const input = _.omit(this.editedItem, ['__typename', 'id']);

    this.$apollo.mutate({
      mutation: CREATE_FLUTE_QUERY,
      variables: { input },
      update: (store, {data: { createFlute }}) => {
        let data: any = store.readQuery({
          query: FLUTES_QUERY
        });

        data.flutes.push(createFlute);

        store.writeQuery({
          query: FLUTES_QUERY,
          data
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        createFlute: {
          __typename: 'Flute',
          id: -1,
          ...input,
        },
      },
    });
  }

  editFlute() {
    const input = _.omit(this.editedItem, ['__typename']);

    this.$apollo.mutate({
      mutation: EDIT_FLUTE_QUERY,
      variables: { input },
      update: (store, {data: { editFlute }}) => {
        let data: any = store.readQuery({
          query: FLUTES_QUERY
        });

        data.flutes = data.flutes.filter(
          flute => flute.id !== this.editedItem.id
        );

        data.flutes.push(editFlute);

        store.writeQuery({
          query: FLUTES_QUERY,
          data,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        editFlute: {
          __typename: 'Flute',
          ...input,
        },
      },
    });
  }

  @Watch('dialog')
  onDialogChange(val) {
    if (!val)
      this.close();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/FluteDatabase.vue